import { initialState } from "./initialState";
import {
  FETCH_DASHBOARD_FILTERED_BATCH_LIST,
  FETCH_DATA,
  FETCH_PRODUCTS_AND_SITES,
  GENERATE_KPI_TABLE,
  GENERATE_KPI_GRAPH,
  SET_SELECTED_BATCH_IDS
} from "./types";

const batchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCTS_AND_SITES:
      return {
        ...state,
        productAndSites: action.payload,
      };

    case FETCH_DATA:
      return {
        ...state,
        parametersData: action.payload,
      };

    case FETCH_DASHBOARD_FILTERED_BATCH_LIST:
      return {
        ...state,
        dashboardBatchData: action.payload,
      };

    case GENERATE_KPI_TABLE:
      return {
        ...state,
        kpitable: action.payload,
      };
    case GENERATE_KPI_GRAPH:
      return {
        ...state,
        kpigraph: action.payload,
      };
    case SET_SELECTED_BATCH_IDS:
      return {
        ...state,
        selectedBatchIds: action.payload,
      };

    default:
      return state;
  }
};

export default batchReducer;
